import React from 'react';
import { Mail, RotateCcw } from 'lucide-react';
export function RefundPolicy() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1563" data-mp="2bguuwxvt7iyp">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1564" data-mp="2be8kmqhjapcs">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1565" data-mp="2q7agids50sxe">
          <div className="flex items-center justify-center mb-4" data-id="element-1566" data-mp="2l6efc7z67kvo">
            <RotateCcw className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-1567" data-mp="2l87mdodp4747" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-1568" data-mp="1xhbpwdyaonqm">REFUND POLICY</h1>
          </div>
        </div>

        {/* Policy Content */}
        <div className="bg-gray-50 rounded-lg p-8 mb-8" data-id="element-1569" data-mp="1sjtkgxjhkqnd">
          <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-1570" data-mp="27fhn4i95p5p5">
            Any request for refunds must be made in writing for verification.
            Any request will be handled on a case-by-case basis.
          </p>

          <div className="bg-white rounded-lg p-6 border-2 border-brand-purple-200" data-id="element-1571" data-mp="3ivzjkicr78bs">
            <div className="flex items-start" data-id="element-1572" data-mp="3duimkxxe460h">
              <Mail className="w-6 h-6 text-brand-purple-600 mr-3 mt-1 flex-shrink-0" data-id="element-1573" data-mp="2il5ryvxrnx1l" />
              <div data-id="element-1574" data-mp="2njh1f5k5g5ja">
                <p className="text-base text-gray-700 mb-2" data-id="element-1575" data-mp="2nixvkn7rx7lm">
                  Please email requests to:
                </p>
                <a href="mailto:customerservice@desertsageseminars.com" className="text-xl font-semibold text-brand-purple-600 hover:text-brand-purple-700" data-id="element-1576" data-mp="2sk4zucapjonj">
                  customerservice@desertsageseminars.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}